// FICHIER : frontend/src/App.js
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage      from "./pages/LandingPage";
import Candidat         from "./pages/Candidats";
import Recruteur        from "./pages/Recruteur";
import Candidature      from "./pages/Candidature";
import Offres           from "./pages/Offres";
import Entreprise       from "./pages/Entreprise";
import Marque           from "./pages/Marque";
import Dashboard        from "./pages/Dashboard";
import OffreCreate      from "./pages/OffreCreate";
import Contenu          from "./pages/Contenu";
import Fonctionnalites  from "./pages/Fonctionnalites";
import CommentCaMarche  from "./pages/CommentCaMarche";
import Contact          from "./pages/Contact";
import RequireAuth      from "./components/RequireAuth";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Pages publiques */}
        <Route path="/"                  element={<LandingPage />}      />
        <Route path="/fonctionnalites"   element={<Fonctionnalites />}  />
        <Route path="/comment-ca-marche" element={<CommentCaMarche />}  />
        <Route path="/contact"           element={<Contact />}          />
        <Route path="/offres"            element={<Offres />}           />
        <Route path="/entreprise"        element={<Entreprise />}       />
        <Route path="/candidature"       element={<Candidature />}      />
        <Route path="/candidats"         element={<Candidat />}         />

        {/* Pages privées — nécessitent un compte entreprise */}
        <Route path="/dashboard"         element={<RequireAuth><Dashboard /></RequireAuth>}    />
        <Route path="/marque"            element={<RequireAuth><Marque /></RequireAuth>}        />
        <Route path="/offre-create"      element={<RequireAuth><OffreCreate /></RequireAuth>}   />
        <Route path="/contenu"           element={<RequireAuth><Contenu /></RequireAuth>}       />
        <Route path="/recruteur"         element={<RequireAuth><Recruteur /></RequireAuth>}     />
      </Routes>
    </BrowserRouter>
  );
}